"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
const minimalInputClasses = "border-0 border-b border-border/60 rounded-md px-0 bg-transparent focus-visible:ring-0 focus-visible:border-primary shadow-sm text-foreground placeholder:text-muted-foreground/40 md:text-lg h-12 transition-colors w-full appearance-none";
function ConnectForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="name" rules={{
        required: "Inserire il nome completo"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Nome e Cognome</FormLabel>
              <FormControl>
                <Input placeholder="Nome e Cognome" className={minimalInputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" rules={{
        required: "Inserire il nome dell'azienda"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Azienda</FormLabel>
              <FormControl>
                <Input placeholder="Azienda" className={minimalInputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="settore_industriale" rules={{
        required: "Selezionare il settore industriale"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Settore Industriale</FormLabel>
              <FormControl>
                <select className={minimalInputClasses} {...field}>
                  <option value="" disabled>Settore Industriale</option>
                  <option value="tessile">Tessile</option>
                  <option value="chimico">Chimico</option>
                  <option value="laboratorio">Laboratorio</option>
                  <option value="altro">Altro</option>
                </select>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "L'indirizzo email è obbligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Inserire un indirizzo email valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Email Aziendale</FormLabel>
              <FormControl>
                <Input type="email" placeholder="Email Aziendale" className={minimalInputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="sr-only">Telefono</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="Telefono (Opzionale)" className={minimalInputClasses} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <div className="hidden md:block" />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Si prega di fornire un messaggio"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Messaggio</FormLabel>
            <FormControl>
              <Textarea placeholder="Descriva le sue necessità tecniche..." className={`${minimalInputClasses} min-h-[120px] resize-none pt-4`} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 border border-destructive/50 bg-destructive/10 text-destructive text-sm rounded-md">
          {submitError}
        </div>}


      <Button type="submit" disabled={isSubmitting} className="w-full h-16 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 text-lg tracking-wider uppercase font-default font-semibold mt-8 shadow-md">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-3 size-5" />
            Invio in corso...
          </> : 'Invia Richiesta'}
      </Button>
    </Form>;
}
export default function ContattaIlNostroUfficioTecnico() {
  return <section data-section-id="226214" id="contatta-il-nostro-ufficio-tecnico" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-background/95 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691233/img/centro_chimica_laboratory_texture.png)] bg-cover bg-center opacity-10 z-0" />
      </div>

      <div className="relative z-20 container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-4">
            Contatta il Nostro Ufficio Tecnico
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto font-default font-normal">Supporto specialistico per forniture industriali e consulenza chimica..</p>
        </div>

        <div className="bg-card/50 backdrop-blur-md p-8 md:p-12 border border-border/40 shadow-xl rounded-lg">
          <FormProvider formId="contact_form_home" sectionName="Contatta il Nostro Ufficio Tecnico" defaultValues={{
          name: "",
          company: "",
          settore_industriale: "",
          email: "",
          phone: "",
          message: ""
        }} successMessage="Grazie per averci contattato. Il nostro ufficio tecnico prenderà in carico la sua richiesta entro 24 ore lavorative.">
            <ConnectForm />
          </FormProvider>

          <div className="mt-12 pt-8 border-t border-border/40 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="font-mono text-sm text-muted-foreground">
              <p>Email: centrochimica@centrochimica.it</p>
              <p>P.IVA: 04492810488</p>
            </div>
            <div className="font-mono text-sm text-muted-foreground md:text-right">
              <p>Viale della Repubblica 298</p>
              <p>59100 Prato (PO), Italia</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}